/**
 * Validate for quantity
 */
export const isValidQuantity = (value: string | number) => {
  const val = String(value)
  return /^-?\d+(\.\d+)?$/.test(val) ? undefined : 'Invalid quantity'
}
